import object from "lodash/object";
import { fetchRequest } from "../../utils/http.ts";
import { getProfileUuid, getAccessToken } from "../../utils/tokens";
import { logError } from "../../components/Errors";
import {
  getUserServiceUrl as userServiceUrl,
  getAuthServiceUrl as authServiceUrl,
  getHttpProtocol as scheme,
} from "../../utils/requests";

export const USER_ERROR = "USER_ERROR";
export function setUserError(err) {
  return {
    type: USER_ERROR,
    error: err,
  };
}

export const SET_USER = "SET_USER";
export function setUser(user) {
  return {
    type: SET_USER,
    user,
  };
}

export const SET_DOCUMENTS = "SET_DOCUMENTS";
export function setDocuments(payload) {
  return {
    type: SET_DOCUMENTS,
    payload,
  };
}

export const VERIFY_USER_TOKEN = "VERIFY_USER_TOKEN";
export function verifyUserToken(token) {
  return async function (dispatch) {
    const verifyTokenUrl = `${scheme}//${authServiceUrl}/verify/${token}`;
    try {
      const response = await fetchRequest({
        path: verifyTokenUrl,
      });
      if (response.ok) {
        const body = await response.json();
        const { sub } = body.payload;
        dispatch(fetchUser(token, sub)); // sub: userUuid
      } else {
        throw new Error(
          `Request returned with invalid status: ${response.status}`,
        );
      }
    } catch (err) {
      logError({
        feature: VERIFY_USER_TOKEN,
        message: err.message,
        request: {
          method: "GET",
          path: verifyTokenUrl,
        },
      });
      dispatch(setUserError(err));
    }
  };
}

export const FETCH_USER = "FETCH_USER";
export function fetchUser(accessToken, uuid) {
  return async function (dispatch, getState) {
    const profileUuid = getProfileUuid();

    if (!profileUuid && !uuid) {
      return dispatch(verifyUserToken(getAccessToken()));
    }

    const fetchUserUrl = !profileUuid
      ? `${scheme}//${userServiceUrl}/user/${uuid}`
      : `${scheme}//${userServiceUrl}/profile/${getProfileUuid()}`;

    const formatResponse = (response) => {
      return {
        email: response.email,
        first_name: response.firstName,
        last_name: response.lastName,
        user_uuid: response.userUuid,
        username: response.username,
        uuid: response.userUuid,
        valid_email: 1,
        isEmailAddressValid: true,
        role: response.membershipRole,
        superuser: response.superuser,
      };
    };
    try {
      const response = await fetchRequest({
        path: fetchUserUrl,
        options: {
          token: accessToken,
        },
      });
      if (response.ok) {
        const body = await response.json();

        const res = !profileUuid ? body : formatResponse(body);
        dispatch(setUser(res));
      } else {
        throw new Error(
          `Request returned with invalid status: ${response.status}`,
        );
      }
    } catch (err) {
      const { client } = getState();
      logError({
        feature: FETCH_USER,
        message: err.message,
        request: {
          method: "GET",
          path: fetchUserUrl,
        },
        user: uuid,
        client: client.data.uuid,
      });
      dispatch(setUserError(err));
    }
  };
}

export const FETCH_DOCUMENTS = "FETCH_DOCUMENTS";
export function fetchDocuments() {
  return async function getDocuments(dispatch, getState) {
    const token = getAccessToken();

    let response = null;

    const state = getState();

    const { data: client } = state.client;

    const fetchDocumentPath = `${scheme}//${userServiceUrl}/documents/${object.get(
      client,
      "uuid",
    )}`;

    try {
      response = await fetchRequest({
        method: "GET",
        path: fetchDocumentPath,
        options: {
          token,
          headers: { "Content-Type": "application/json" },
        },
      });
      if (response && response.ok) {
        const { data } = await response.json();
        dispatch(setDocuments(data));
      }
    } catch (err) {
      logError({
        feature: FETCH_DOCUMENTS,
        message: err.message,
        request: {
          method: "GET",
          path: fetchDocumentPath,
        },
      });
      dispatch(setUserError(err));
    }
  };
}
